import { motion } from "framer-motion";
import AccountsPage from '../AccountsPage';
import AccountBalancePage from '../AccountBalancePage';
import Settings from '../Settings';

// Page renderer utility component
export const PageRenderer = ({ page, index, isInitialLoad, setAppLocation, chatId, animationDirectionsRef }) => {
  const zIndex = index + 1; // Z-index based on stack position

  // Animation variants using the direction from ref
  const pageVariants = {
    initial: () => {
      const direction = animationDirectionsRef.current;
      if (isInitialLoad) return { transform: "translateX(0)", opacity: 0 };
      return {
        transform: direction === 'LTR' ? "translateX(-100vw)" : "translateX(100vw)",
        opacity: 0
      };
    },
    animate: {
      transform: "translateX(0)",
      opacity: 1
    },
    exit: () => {
      const direction = animationDirectionsRef.current;
      return {
        transform: direction === 'LTR' ? "translateX(100vw)" : "translateX(-100vw)",
        opacity: 0
      };
    }
  };

  const pageProps = {
    setAppLocation,
    chat: chatId
  };

  let PageComponent;

  switch (page.type) {
    case 'accounts':
      PageComponent = AccountsPage;
      break;
    case 'account-balance':
      PageComponent = AccountBalancePage;
      pageProps.accountId = page.data.accountId;
      break;
    case 'settings':
      PageComponent = Settings;
      break;
    default:
      return null;
  }

  return (
    <motion.div
      style={{ position: "absolute", width: "100%", zIndex }}
      key={`${page.type}-${page.timestamp}`}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2 }}
    >
      <PageComponent {...pageProps} />
    </motion.div>
  );
};
